<template>
  <Page404 v-if="page404" />
  <div class="team" v-else-if="teamData">
    <XNav
      :content="[
        { t: 'common.teams' },
        { name: teamName },
      ]"
    />
    <TeamBanner
      :team-name="teamName"
      :team-id="$route.params.id"
    />
    <TeamOverviewTable :content="teamData" :team-id="$route.params.id" />
  </div>
</template>

<script>
import axios from "axios";
import TeamBanner from "@/components/TeamBanner.vue";
import XNav from "@/components/XNav.vue";
import TeamOverviewTable from "@/components/tables/TeamOverviewTable.vue";
import Page404 from "@/views/404.vue";
export default {
  components: {
    TeamBanner,
    XNav,
    TeamOverviewTable,
    Page404,
  },
  metaInfo() {
    return {
      title: this.$t("seo_metadata.team_overview.title", { team: this.teamName }),
      meta: [
        { vmid: "description", name: "description", content: this.$t("seo_metadata.team_overview.description", { team: this.teamName }) },
        { vmid: "keywords", name: "keywords", content: this.$t("seo_metadata.keywords") },
        { vmid: "og:title", property: "og:title", content: this.$t("seo_metadata.team_overview.title", { team: this.teamName }) },
        { vmid: "og:description", property: "og:description", content: this.$t("seo_metadata.team_overview.description", { team: this.teamName }) },
        { vmid: "og:url", property: "og:url", content: `https://kingsleague.ca/team/${this.$route.params.id}` },
        { vmid: "og:type", property: "og:type", content: "website"},
        { vmid: "twitter:title", name: "twitter:title", content: this.$t("seo_metadata.team_overview.title", { team: this.teamName }) },
        { vmid: "twitter:description", name: "twitter:description", content: this.$t("seo_metadata.team_overview.description", { team: this.teamName }) }
      ],
      link: [{ rel: "canonical", href: "https://kingsleague.ca" + this.$route.path }]
    };
  },
  data(){
    return{
      teamData: null,
      teamName: null,
      page404: false,
    }
  },
  created(){
    this.loadData();
  },
  methods: {
    loadData(){
      axios.get(`${this.$apiUrl}/teamOverview/${this.$route.params.id}`)
      .then((res) => {
        this.teamData = res.data;
        this.teamName = this.teamData[0].Team;
        this.$store.dispatch("pageLoad", false)
      })
      .catch((err) => {
        console.log(err);
        this.page404 = true;
        this.$store.dispatch("pageLoad", false)
      });
    }
  }
}
</script>
